require("./globaldata_get.js");
require("./globaldata_set.js");
require("./globaldata_changeby.js");
